import withMenu from 'components/common/withMenu'
import IndividualTreasuryItemLoadingComponent from 'components/IndividualTreasuryItemLoading/IndividualTreasuryItemLoadingComponent'
import GlobalContainer from 'components/layout/globalContainer'
import { P_INDIVIDUAL_TREASURY_ITEM_LOADING } from 'constants/ConfigProcessNames'
import React, { Component } from 'react'
import { Row } from 'react-bootstrap'

class IndividualTreasuryItemLoading extends Component {
	myRef: any = React.createRef()

	getShortcuts = () => {
		const shortcuts = [
			{
				hotkey: {
					charCode: '40',
					modifiers: ['arrowDown', 'arrowUp' /*, "arrowLeft", "arrowRight", */]
				},
				action: this.moveArrow,
				name: 'Arrow move',
				description: 'Arrow move'
			},
			{
				hotkey: { charCode: '65', modifiers: ['insert'] },
				action: this.addToCart,
				name: 'Add Product',
				description: 'Add product to car'
			}
		]

		return shortcuts
	}

	moveArrow = () => {}

	handleCallBackButton = () => {
		if (this.myRef.current) {
			this.myRef.current.handleConfirmComponent()
		}
	}

	addToCart = async (
		event: Event & {
			target: HTMLInputElement
		}
	) => {
		if (event.target.id) {
			this.myRef.current.preventAddToCart()
		}
	}

	render() {
		const containerProps = {
			codeProcess: P_INDIVIDUAL_TREASURY_ITEM_LOADING,
			callBackButton: this.handleCallBackButton,
			nextPage: true,
			shortcuts: this.getShortcuts()
		}

		const propsComponent = {
			ref: this.myRef
		}

		return (
			<Row>
				<GlobalContainer {...containerProps}>
					<IndividualTreasuryItemLoadingComponent {...propsComponent} />
				</GlobalContainer>
			</Row>
		)
	}
}

export default withMenu(IndividualTreasuryItemLoading)
